module.exports = __webpack_public_path__ + "assets/3bf80dedb16442f37ec554bf63dc13de.svg";